import DOMPurify from 'isomorphic-dompurify';
import MarkdownIt from 'markdown-it';

const markdown = MarkdownIt({ linkify: true, typographer: true });

const renderedMarkdownCache = new Map<string, string>();

/**
 * Renders Markdown to sanitized HTML, memoizing by source.
 *
 * Sanitizes the rendered HTML, not the Markdown source — sanitizing Markdown is
 * a no-op and would leave us exposed if markdown-it ever emits raw HTML.
 */
export const renderSanitizedMarkdown = (source: string): string => {
  let html = renderedMarkdownCache.get(source);
  if (html === undefined) {
    html = DOMPurify.sanitize(markdown.render(source));
    renderedMarkdownCache.set(source, html);
  }
  return html;
};

export default renderSanitizedMarkdown;
